import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { specialitiesActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class Specialities extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newSpeciality, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Especialidades'}
          classes={classes}
          newResource={newSpeciality}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'especialidades'}
        />

        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.specialities.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(specialitiesActions.openModal())
    },
    closeModal: () => {
      dispatch(specialitiesActions.closeModal())
    },
    newSpeciality: speciality => {
      dispatch(specialitiesActions.newFormSpeciality(speciality))
    },
    resetState: () => {
      dispatch(specialitiesActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Specialities))



// WEBPACK FOOTER //
// ./src/containers/Specialities/index.js